/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState } from "react";
import $ from "jquery";
import { useWallet } from '../WalletProvider';
import swal from "sweetalert";
import {ERC20ABI} from "../../common"
import {getTokenAddress,getNFTAddress, handleManualData,get1155Address,uploadData, handleManualData1155, matchTokenData, matchNFTData,match1155Data} from "../helpers/helper"

function VerificationTab() {
    const {account,currencyDetails} = useWallet();
    const [fileData, setFileData] = useState();
    const [validData, setValidData] = useState([]);
    const [contractList, setContractList] = useState([])
    const [invalidData, setInvalidData] = useState([]);
    const [duplicateData, setDuplicateData] = useState([]);
    const [token, setToken] = useState(null);
    const [showNextTab, setShowNextTab] = useState(false);
    const [fileName, setFileName] = useState("Add File");
    const [showSecond, setShowSecond] = useState(false);
    const [manualEntry, setManualEntry] = useState("");
    const [commonAmt, setCommonAmt] = useState(0);
    const [toggleToken, setToggleToken] = useState(true);
    const [deflationary, setDeflationary] = useState(false);
    const [erc1155, setErc1155] = useState(false);
    const [transactionHash, setTransactionHash] = useState('');
    const [matchedData, setMatchedData] = useState({
        match: 0,
        unMatch: 0,
        result : false
    })
    const address = sessionStorage.getItem("address") || account;

    const RestoreAll= ()=>{
        setFileData();
        setValidData([]);
        setContractList([])
        setInvalidData([]);
        setDuplicateData([]);
        setToken(null);
        setShowNextTab(false);
        setFileName("Add File");
        setShowSecond(false);
        setManualEntry("");
        setCommonAmt(0);
    };
    const ManualData = async(e)=>{
        if(manualEntry.replace(/^\s+|\s+$/gm,'') !== ""){
          const handleManualEntry = await handleManualData(e, currencyDetails.web3Obj, manualEntry.replace(/^\s+|\s+$/gm,''), toggleToken)
          setValidData(handleManualEntry.valid);
          setDuplicateData(handleManualEntry.duplicate);
          setInvalidData(handleManualEntry.invalid);
          setShowNextTab(true);
        }else{
          swal( "Please enter a valid data", { buttons: false, icon: "error", timer: 2000 });
        }
         
    };

    const ManualData1155 = async(e)=>{
      if(manualEntry.replace(/^\s+|\s+$/gm,'') !== ""){
        const handleManualEntry = await handleManualData1155(e, currencyDetails.web3Obj, manualEntry.replace(/^\s+|\s+$/gm,''))
        setValidData(handleManualEntry.valid);
        setDuplicateData(handleManualEntry.duplicate);
        setInvalidData(handleManualEntry.invalid);
        setShowNextTab(true);
      }else{
        swal( "Please enter a valid data", { buttons: false, icon: "error", timer: 2000 });
      }
         
    };

    const addCommonAmount = ()=>{
        let ar = manualEntry.split(/[\n,]+/); 
        let str = "";
        for (var i = 0; i < ar.length; i++) {
                str = str+ar[i]+","+commonAmt+"\n"
        }
        setManualEntry(str);
        $("#amount-modal-close").click();
    };

    async function getContracts(){
        if (address !== null && address !== undefined && address !== '') {
            $('.ajax-loader').css("display", "flex");
            let Arr;
            if(toggleToken === true){
                Arr = await getTokenAddress(currencyDetails.endPoint, address);
            }else{
                if(!erc1155){
                    Arr = await getNFTAddress(currencyDetails.endPoint, address);
                }else{
                    Arr = await get1155Address(currencyDetails.endPoint, address);
                }
               
            }

            if (Arr.length > 0) {
                $('.ajax-loader').css("display", "none");
                let key = "contractAddress"
                const unique = [...new Map(Arr.map(item =>
                    [item[key], item])).values()];
                    setContractList(unique);
            }else{
                $('.ajax-loader').css("display", "none");
                swal(`Tokens not found in wallet`, {button: false,icon: "warning", timer:2000})
            }
        }else{
            swal(`Please connect to the wallet first`, {button: false,icon: "warning", timer:2000})
        }
    };

    function displayTableData(){
        
        if(erc1155){
            return (<>
                <thead>
                    <tr>
                        <th scope="col">Address</th>
                        <th scope="col">ID</th>
                        <th scope="col">Count</th>
                    </tr>
                </thead>
                <tbody>
                    {console.log(validData)}
                    {validData.map((item)=>{
                        return(<tr key = {item.address}>
                            <td>{item.address}</td>
                            <td>{item.id}</td> 
                            <td>{item.count}</td>
                        </tr>)
                    })}
                </tbody>
            </>)
        }else{
            return (<>
                <thead>
                    <tr>
                        <th scope="col">Address</th>
                        <th scope="col">{toggleToken ? 'Amount' : 'ID'}</th>
                    </tr>
                </thead>
                <tbody>
                
                    { toggleToken ? validData.map((item)=>{
                        return(<tr key = {item.address}>
                            <td>{item.address}</td>
                            <td>{item.amount}</td>
                        </tr>)
                    }): validData.map((item)=>{
                        return(<tr key = {item.address}>
                            <td>{item.address}</td>
                            <td>{item.id}</td>
                        </tr>)
                    })}
                </tbody>
            </>)
        }
    
    };

    const fileUpload = async() => {
        const file = await uploadData(toggleToken, erc1155, fileData);
        if(!file){
            swal(`Error while uploading your file`, {button: false,icon: "error",timer:2000})
        }else{
              setValidData(file.valid);
              setDuplicateData(file.duplicate);
              setInvalidData(file.invalid);
              setShowNextTab(file.next);
        }
        
    }

    const getTransactions = async() => {
        const txRegex = /^0x([A-Fa-f0-9]{64})$/ ;
        if(transactionHash !== '' && txRegex.test(transactionHash)){
            if(token !== null){
                const web3Obj = currencyDetails.web3Obj;
                const transaction = await web3Obj.eth.getTransaction(transactionHash);
                const methodId = transaction.input.slice(0, 10);
                const type = toggleToken ? ['address', 'address[]','uint256[]','uint256','bool'] : ['address', 'address[]','uint256[]','uint256[]','uint8']
                const dataStaring = transaction.input.split(methodId);
                const hex = "0x".concat(dataStaring[1]);
                const input = await web3Obj.eth.abi.decodeParameters(type, hex);
                const tokenAddress = input[0];
                const recipentAddress = input[1];
                var idArr; var idCountArr; var amountArr; var decimal;
                if(toggleToken){
                    amountArr = input[2];
                }else{
                    idArr = input[2];
                    idCountArr = input[3];
                }
        
                if(validData.length > 0){
                    setMatchedData({
                        match:0,
                        unMatch:0,
                        result : false
                    })
                    if( tokenAddress.toUpperCase() === token.toUpperCase() ){
                        for (let j = 0; j < validData.length; j++) {
                            if( validData[j].address.toUpperCase() === recipentAddress[j].toUpperCase() ){
                                var match = false;
                                if(toggleToken){
                                    const contract = await new web3Obj.eth.Contract(ERC20ABI,tokenAddress);
                                    decimal = await contract.methods.decimals().call();
                                }
                                if(toggleToken){
                                    match = await matchTokenData(decimal, validData[j].amount, Number(amountArr[j]));
                                }else{
                                    if(!erc1155){
                                        match = await matchNFTData(validData[j].id, Number(idArr[j]));
                                    }else{
                                        match = await match1155Data( validData[j].id, validData[j].count, Number(idArr[j]), Number(idCountArr[j]), Number(idCountArr[j]));
                                    } 
                                }
                                if(match){
                                    setMatchedData(matchedData => {
                                        return { 
                                        ...matchedData, 
                                        match: matchedData.match + 1 
                                        }
                                    })
                                }else{
                                    setMatchedData(matchedData => {
                                        return { 
                                        ...matchedData, 
                                        unMatch: matchedData.unMatch + 1 
                                        }
                                    })
                                }  
                            }else{
                                setMatchedData(matchedData => {
                                    return { 
                                    ...matchedData, 
                                    unMatch: matchedData.unMatch + 1 
                                    }
                                })
                            }   
                        }
                        setMatchedData(matchedData => {
                            return { 
                            ...matchedData, 
                            result: true 
                            }
                        })
                    }else{
                        swal( "Token contract doesn't match", { buttons: false, icon: "error", timer: 2000 });
                    }
                }else{
                    swal( "Please enter a valid data to match", { buttons: false, icon: "error", timer: 2000 });
                }
            }else{
                swal( "Please choose a token first", { buttons: false, icon: "error", timer: 2000 });
            }
        }else{
            swal( "Please enter a valid transaction hash", { buttons: false, icon: "error", timer: 2000 });
        }
        
    }

  return (
    <>
        {!showSecond && <div className="tab-pane" id="step1">
        <div className="toggleBtn">
            <span style={{marginRight: "20px"}}>TOKEN</span>
            <input type="checkbox" hidden="hidden" id="username" value={toggleToken} onChange={()=>{setToggleToken(!toggleToken)}}/>
            <label className="switch" htmlFor="username"></label>
            <span style={{position: "relative",   right: "0px"}}>NFT</span>
        </div>
        <ul>
          <li key="firstComponent">
            <label>Select crypto asset to MultiTokendrop</label>
            <div className="errorTxt"></div>
            <div style={{display:"flex", marginBottom:"20px"}}>
                <select
                    name=""
                    style={{marginBottom:"0px"}}
                    onClick={getContracts}
                    onChange={(events) => {
                        setToken(events.target.value);
                    }}
                    >
                    <option value={null}>Select</option>
                    {contractList.map((item)=>{
                        return(<option key ={item.contractAddress} value={item.contractAddress}>{item.tokenSymbol}-{item.contractAddress}</option>)
                    }) }
                </select>
                {toggleToken ?
                <>
                    <div style={{backgroundColor: "#124070",borderRadius: "8px",marginLeft:"10px",padding: "2px 20px"}}>
                        <div className="" style={{fontSize: "12px"}}>Deflationary</div>
                            <div className="toggleBtn toggleBtn2">
                                <span style={{marginRight: "20px"}}>OFF</span>
                                <input type="checkbox" hidden="hidden" id="username1" value={deflationary} onChange={()=>{setDeflationary(!deflationary)}}/>
                                <label className="switch" htmlFor="username1"></label>
                                <span style={{position: "relative", right: "0px"}}>ON</span>
                            </div>
                    </div>
                </>:
                <>
                <div style={{backgroundColor: "#124070",borderRadius: "8px",marginLeft:"10px",padding: "2px 20px"}}>
                        <div className="" style={{fontSize: "12px"}}>ERC</div>
                            <div className="toggleBtn toggleBtn2">
                                <span style={{marginRight: "20px"}}>721</span>
                                <input type="checkbox" hidden="hidden" id="username2" value={erc1155} onChange={()=>{setErc1155(!erc1155)}}/>
                                <label className="switch" htmlFor="username2"></label>
                                <span style={{position: "relative",   right: "0px"}}>1155</span>
                            </div>
                    </div>
                </>}
            </div>
            <div>
                <label>Enter transaction hash</label>
                <input type="text" value={transactionHash} onChange={(events)=>{setTransactionHash(events.target.value)}}/>
            </div>  
          </li>
          <li key="randomkey1">
            <div className="container">
              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="tabbable-panel">
                    <div className="tabbable-line">
                    <ul className="nav nav-tabs ">
                        <li
                          key="randomkey4"
                          className="active"
                          id="hidediv"
                          style={{ display: "none !important" }}
                        >
                          <a href="#tab_default_1" data-toggle="tab"></a>
                        </li>
                        <li key="randomkey3">
                          <a href="#tab_default_4" data-toggle="tab">
                            Manual Entry{" "}
                          </a>
                        </li>
                        <li key="randomkey2" className="active">
                          <a href="#tab_default_5" data-toggle="tab">
                            Upload File{" "}
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div
                          className="tab-pane active"
                          id="tab_default_1"
                        ></div>
                        <div className="tab-pane" id="tab_default_4">

                        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header py-0">
                                    <h5 className="modal-title" id="exampleModalLabel">Add Amount To All</h5>
                                    <button type="button" id="amount-modal-close" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                <div className="">
                                    <input type="number" onChange={(e)=>{setCommonAmt(e.target.value)}} style={{backgroundColor: "#ffffff29 !important",height: "38px"}} />
                                    <button type = "button" className="modalbtn" onClick={addCommonAmount}>Set</button>
                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        
                        {toggleToken && <button type="button" className="addbtn" data-toggle="modal" data-target="#exampleModal">
                             Add Amount
                        </button>}
                            <textarea 
                                name = "commentTextArea"
                                type="text"
                                placeholder={toggleToken  ? "Make sure to enter one address and one value on each line": "Make sure to enter one address and one ID on each line"}
                                value = {manualEntry}
                                onChange={e => setManualEntry(e.target.value)}
                                >
                            </textarea>
                          
                          {!erc1155 ? <button
                            className="next-btn next-btn1"
                            type="button"
                            onClick={(e)=>{ManualData(e)}}
                          >
                            Continue
                          </button>:<button
                            className="next-btn next-btn1"
                            type="button"
                            onClick={(e)=>{ManualData1155(e)}}
                          >
                            Continue
                          </button> }
                        </div>
                        <div className="tab-pane active" id="tab_default_5">
                          <div className="drop-zone d-block drop-text">
                            <span className="drop-zone__prompt">
                              Drop file here or click to upload
                            </span>

                            <label className="filelabel">
                              <i className="fa fa-paperclip"></i>
                              <span className="title">{fileName}</span>
                              <input
                                type="file"
                                className="my-3 FileUpload1"
                                onChange={(event) => {
                                  setFileName(event.target.files[0].name);
                                  setFileData(event.target.files[0]);
                                }}
                                id="FileInput"
                                name="booking_attachment"
                              />
                            </label>
                            <button
                              className="next-btn next-btn1 upload-bttn"
                              type="button"
                              onClick={fileUpload}
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="headerer">
              <label className="add-lable" style={{ margin: "0px" }}>
                <b>List of Addresses in CSV</b>
              </label>
              <a className=" showcsv trigger" href="/">
                Show Sample CSV
              </a>
            </div>
            {validData.length > 0 && <div className="container my-4">
                <table className="table" style={{color:"#fff"}}>
                    {displayTableData()}
                </table>
            </div> }
            

          </li>
          {showNextTab && (
            <>
              <li
                key="thirdComponent"
                className="mb-2"
                style={{ listStyle: "none", display: "inline" }}
              >
                <button
                  className="next-btn next-btn1"
                  type="button"
                  onClick={getTransactions}
                >
                  Proceed with above data
                </button>
              </li>
              <li
                key="fourthComponent"
                style={{ listStyle: "none", display: "inline" }}
              >
                <button
                  className="next-btn next-btn1"
                  type="button"
                  onClick={RestoreAll}
                >
                  Reload Data
                </button>
              </li>
            </>
          )}
        </ul>

        {token === null ? (
          <div className="dangerCss">⚠ Please select token first</div>
        ) : null}
        {transactionHash === '' ? (
          <div className="dangerCss">⚠ Please enter a transaction has first</div>
        ) : null}
        


        {matchedData.result && 
        <>
            <div className="dangerCss showmsg3" style={{background: "rgb(0 0 0)",border: "1px solid #ff9c00"}}>
                <p>Total record: {validData.length}</p>
                <p>Matched record: {matchedData.match}</p>
                <p>Unmatched record: {matchedData.unMatch}</p>
            </div>
        </>
        }
        {duplicateData.length > 0 ? (
          <div className="dangerCss">
            {duplicateData.map((item,i) => {
              return (
                <span key={i}>
                  ⚠ Duplicate address {item.address}
                  <br />
                </span>
              );
            })}
          </div>
        ) : null}

        {invalidData.length > 0 ? (
          <div className="dangerCss">
            <div className="">
              ⚠ Please provide a corresponding amount for each
              address. Click 'Show Sample CSV' for more details.
            </div>
            <div>Data with errors</div>
            {invalidData.map((item,i) => {
              return (
                <span key={i}>
                  ⚠ address {item}
                  <br />
                </span>
              );
            })}
          </div>
        ) : null}
      </div>}
    </>
  )
}

export default VerificationTab